  // Bundle Progress Bar block script
  const bundleSteps = document.querySelectorAll('.slider-wrapper .step');
  const fillLine = document.querySelector('.slider-wrapper .progress-fill');
  const defaultVariant = document.querySelector('.variant-id-form');
  defaultVariant.remove();
  

  bundleSteps.forEach((step, index) => {
    step.addEventListener('click', () => {
      // Remove active from all
      bundleSteps.forEach((s) => s.classList.remove('active'));
      // Mark up to current as active
      for (let i = 0; i <= index; i++) {
        bundleSteps[i].classList.add('active');
      }
      // Fill width based on position
      const fillPercent = (index / (bundleSteps.length - 1)) * 100; // left+right padding offset
      fillLine.style.width = `${fillPercent}%`;
      // fillLine.style.background = "#000";
    });
  });

  // Default position (2 Games active)
  // bundleSteps[0].classList.add('active');
  // bundleSteps[1].classList.add('active');
  // fillLine.style.width = '27%';

  // end bundle progress bar block

  // start tabs block script
const tabs = document.querySelectorAll('.tab');
const tabContents = document.querySelectorAll('.tab-content');
const scrollFooter = document.querySelector('.scroll-footer');

/**
 * Updates the visual state of the bundle progress tracker (steps and fill bar).
 * @param {number} currentQty The total number of games currently in the cart or selection.
 */
function updateBundleTrackerCumulative(currentQty) {
    const qty = parseInt(currentQty, 10);
    const tracker = document.querySelector('.bundle-track');
    const fillBar = document.querySelector('.bundle-fill .progress-fill');
    const bundleSteps = document.querySelectorAll('.slider-wrapper .step');
    
    if (isNaN(qty) || qty < 1 || !tracker || !fillBar) {
        // Reset fill bar and exit if invalid quantity or elements are missing
        if (fillBar) fillBar.style.width = '0%';
        tracker.querySelectorAll('.bundle-step').forEach(step => step.classList.remove('active'));
        return; 
    }

    const allSteps = tracker.querySelectorAll('.bundle-step');
    let maxStepToActivate;
    let targetWidthPercentage = 0;

    // 1. Determine the maximum step index to activate (new thresholds)
    // Step 1: 1-2 products, Step 2: 3 products, Step 3: 4 products, Step 4: 5+ products
    if (qty === 1) {
      maxStepToActivate = 1;
    } else if (qty === 2) {
      maxStepToActivate = 2;
    } else if (qty === 3) {
      maxStepToActivate = 3;
    } else if (qty >= 4) {
      maxStepToActivate = 4;
    } else {
      return;
    }

    // 2. Calculate the target width for the bundle-fill element
    if (maxStepToActivate === 1) {
      targetWidthPercentage = 0;
    } else if (maxStepToActivate === 2) {
      targetWidthPercentage = 33.3333;
    } else if (maxStepToActivate === 3) {
      targetWidthPercentage = 66.1117;
    } else if (maxStepToActivate === 4) {
      targetWidthPercentage = 100;
    }

    // 3. Apply the calculated width to the fill bar
    fillBar.style.width = `${targetWidthPercentage}%`;

    // 4. Apply the 'active' class to the steps (Cumulative Logic)
    allSteps.forEach(step => {
        const stepNumber = parseInt(step.getAttribute('data-step'), 10);
        if (stepNumber <= maxStepToActivate) {
            step.classList.add('active');
        } else {
            step.classList.remove('active');
        }
    });
}

function get_total_qty(){
    let totalQuantity = 0;
    const bundleItemsContainer = document.getElementById('bundle-items');
    if (bundleItemsContainer) {
        bundleItemsContainer.innerHTML = '';
    }
      document.querySelectorAll('.games-list .product-card .count').forEach(qtyElement => {
          const qtyText = qtyElement.textContent.trim();
          const quantity = parseInt(qtyText);
          const variantId = qtyElement.getAttribute("data-variant-id");
          if (!isNaN(quantity) && quantity > 0) {
              totalQuantity += quantity;
              if (bundleItemsContainer) {
                const hiddenInput = document.createElement('input');
                hiddenInput.type = 'hidden';
                hiddenInput.name = `items[][id]`; 
                hiddenInput.value = variantId;
                const hiddenQtyInput = document.createElement('input');
                hiddenQtyInput.type = 'hidden';
                hiddenQtyInput.name = `items[][quantity]`;
                hiddenQtyInput.value = quantity;
                bundleItemsContainer.appendChild(hiddenInput);
                bundleItemsContainer.appendChild(hiddenQtyInput);
            }

          } else {
              console.warn(`Could not parse quantity for element: ${qtyText}`);
          }
      });
      console.log(totalQuantity);
      updateBundleTrackerCumulative(totalQuantity);

      // ✅ ADDED SUBTOTAL LOGIC BELOW
      updateSubtotalAllTabs();
}

// ✅ New function to calculate total price from all tabs
function updateSubtotalAllTabs() {
  let subtotal = 0;
  let totalQuantity = 0;
  
  document.querySelectorAll('.games-list .product-card .count').forEach(countEl => {
    const qty = parseInt(countEl.textContent.trim());
    const price = parseFloat(countEl.getAttribute('data-variant-price'));
    if (!isNaN(qty) && !isNaN(price) && qty > 0) {
      subtotal += qty * price;
      totalQuantity += qty;
    }
  });

  // Apply discount based on total quantity
  let discountMultiplier = 1; // No discount by default
  if (totalQuantity >= 4) {
    discountMultiplier = 0.75; // 25% discount for 4+ items
  } else if (totalQuantity === 3) {
    discountMultiplier = 0.85; // 15% discount for 3 items
  } else if (totalQuantity === 2) {
    discountMultiplier = 0.9; // 10% discount for 2 items
  }

  const discountedSubtotal = subtotal * discountMultiplier;

  const subtotalDiv = document.querySelector('.total-original-price');
  if (subtotalDiv) {
    subtotalDiv.textContent = `${discountedSubtotal.toFixed(2)}`;
  }
}

function showTab(tabId) {
  // Toggle active class for tabs
  tabs.forEach(t => {
    t.classList.toggle('active', t.dataset.tab === tabId);
  });

  // Toggle visible tab content
  tabContents.forEach(content => {
    content.classList.toggle('active-tab-content', content.dataset.tab === tabId);
  });

  // Handle scroll footer
  const activeTabContent = document.querySelector(`.tab-content[data-tab="${tabId}"]`);
  if (!activeTabContent) return;

  const needScroll = activeTabContent.scrollHeight > activeTabContent.clientHeight + 10;
  scrollFooter.style.display = needScroll ? 'block' : 'none';

  activeTabContent.addEventListener('scroll', () => {
    const { scrollTop, scrollHeight, clientHeight } = activeTabContent;
    if (scrollTop + clientHeight >= scrollHeight - 5) {
      scrollFooter.style.display = 'none';
    } else if (needScroll) {
      scrollFooter.style.display = 'block';
    }
  });
}

// Click handler
tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    showTab(tab.dataset.tab);

    // ✅ Keep showing full subtotal (not reset)
    updateSubtotalAllTabs();
  });
});

// Initialize default active tab
const activeTab = document.querySelector('.tab.active');
if (activeTab) showTab(activeTab.dataset.tab);

// counter logic
document.querySelectorAll('.games-list .product-card').forEach(card => {
  const addBtn = card.querySelector('.add-button');
  const counter = card.querySelector('.counter');
  const minusBtn = counter.querySelector('.minus');
  const plusBtn = counter.querySelector('.plus');
  const countEl = counter.querySelector('.count');
  let count = parseInt(countEl.textContent.trim(), 10);
  if (isNaN(count)) count = 0;

  // Show counter and hide add button
  addBtn.addEventListener('click', () => {
    // Initialize quantity at 1 on first add click
    if (count === 0) {
      count = 1;
      countEl.textContent = count;
    }
    addBtn.classList.add('hide');
    counter.classList.add('show');
    get_total_qty();
  });

  // Increase count
  plusBtn.addEventListener('click', () => {
    count++;
    countEl.textContent = count;
    get_total_qty();
  });

  // Decrease count
  minusBtn.addEventListener('click', () => {
    if (count > 0) {
      count--;
      countEl.textContent = count;
    }
    if (count === 0) {
      counter.classList.remove('show');
      addBtn.classList.remove('hide');
    }
    get_total_qty();
  });
});